var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.error)?_c('p',[_vm._v(" Failed to redirect. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }